/**
 * Sürüm başlıkları (GUNCELLEME-VE-SURUM.md §3).
 * Her istemci isteği bu iki başlığı taşır; sunucu minAppVersion altını 426 ile reddeder.
 */
export const APP_VERSION_HEADER = 'x-app-version';
export const RUNTIME_VERSION_HEADER = 'x-runtime-version';

/** İstemci türü; panel ve şoför uygulaması ayrı minimum sürüm politikası taşıyabilir. */
export const APP_CLIENT_HEADER = 'x-app-client';
export const APP_CLIENTS = ['panel', 'driver', 'owner'] as const;
export type AppClient = (typeof APP_CLIENTS)[number];

/** HTTP 426 Upgrade Required — eski istemciyi durduran yanıt kodu. */
export const HTTP_UPGRADE_REQUIRED = 426;

export interface AppManifest {
  server: { time: string; apiVersion: string };
  app: {
    minAppVersion: string;
    latestAppVersion: string;
    currentRuntimeVersion: number;
    apkUrl: string | null;
    releaseNotes: string | null;
  };
  access: {
    status: 'active' | 'readonly' | 'suspended';
    graceUntil: string | null;
    message: string | null;
  } | null;
  flags: Record<string, boolean>;
  /**
   * Bildirim sessiz saati (N1). Kimlik doğrulanmışsa dolu, değilse null. Mobil sessiz saati
   * YALNIZ OWNER/MANAGER için yerelde uygular (`quietExempt` olmayanları bastırır); şoför
   * (DRIVER) bildirimleri sessiz saatten muaftır, sunucu da onlara sessiz saatte push gönderir.
   * Saat `timezone`'dadır.
   */
  notifications: { quietHours: { start: string; end: string }; timezone: string } | null;
  /**
   * Mobilin okuduğu kiracı ayarları. Kimlik yoksa null (`notifications` ile aynı davranış).
   * `eveningLoadFromHour`: akşam dolumunun açılabileceği en erken İstanbul saati (varsayılan 15).
   */
  settings: { eveningLoadFromHour: number } | null;
}
